export const PAGES_WITHOUT_SIDEBAR = [
  'login',
  // public survey preview
  'survey',
]
